import ApiService from './ApiService';

const LogService = {
    // logError: (data, service = ApiService()) =>
    //     service
    //         .post('/Logging/error', data, true, true)
    //         .then((response) => response)
    //         .catch((error) => error),
    // logWarn: (data, service = ApiService()) =>
    //     service
    //         .post('/Logging/warn', data, true, true)
    //         .then((response) => response)
    //         .catch((error) => error.response),
    // logDebug: (data, service = ApiService()) =>
    //     service
    //         .post('/Logging/debug', data, true, true)
    //         .then((response) => response)
    //         .catch((error) => error.response),
    logInfo: (data, service = ApiService()) =>
        service
            .post('/Logging/info', {
                message: data,
                "source": "BP warranty",
            }, true, true)
            .then((response) => {
                return response;
            })
            .catch((error) => error.response),
};

export default LogService;
